import { BidResultsActionTypes, BidResultsActionUnion } from './actions';
import { BidResultsState, BidResultsWithType } from './state';

export const initialBidResultsState: BidResultsState = {
  bidResults: undefined,
  loading: false,
  loaded: false,
  error: undefined
};

export function bidResultsReducer(
  state: BidResultsState = initialBidResultsState,
  action: BidResultsActionUnion
): BidResultsState {
  switch (action.type) {
    case BidResultsActionTypes.LoadBidResults:
      return {
        ...state,
        bidResults: undefined,
        loading: true,
        loaded: false,
        error: undefined
      };
    case BidResultsActionTypes.LoadBidResultsSuccess:
      return {
        ...state,
        bidResults: action.payload,
        loading: false,
        loaded: true
      };
    case BidResultsActionTypes.LoadBidResultsFail:
      return { ...state, error: action.payload, loading: false };
    case BidResultsActionTypes.ResetBidResults:
      return initialBidResultsState;
    default:
      return state;
  }
}

export const getBidResults = (state: BidResultsState): BidResultsWithType =>
  state.bidResults;
